import React, { useEffect } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./protectedRoute";

import {
  Service,
  SubService,
  ServiceDetail,
  Cancellation,
  Booked,
  Appointment,
  AppointmentBooking,
  ServiceChannel,
  ActionConfirmation,
  OtpForm,
  ApptBookingConfirmation,
  ApptBookingAcknowledgement,
  CallApptBookingConfirmation,
  CallApptBookingAcknowledgement,
  AppointmentExistence,
  SingPass,
  SingPassCallBack,
  NoAppointment,
  Story,
  XLanding,
  XVerification,
  XChooseIdType,
  XAppointment,
  XConfirmation,
  XAppointmentDetail,
  XCancelSuccess
} from "pages";

import {
  DEFAULT_ROUTE,
  MAIN,
  SUB_SERVICE,
  SUB_SERVICE_DETAIL,
  CANCELLATION,
  BOOKED,
  APPOINTMENT_BOOKING,
  APPOINTMENT,
  SERVICE_CHANNEL,
  ACTION_CONFIRMATION,
  OTP_FORM,
  APPOINTMENT_CONFIRMATION,
  APPOINTMENT_ACKNOWLEDGEMENT,
  CALL_APPOINTMENT_CONFIRMATION,
  CALL_APPOINTMENT_ACKNOWLEDGEMENT,
  APPOINTMENT_EXISTENCE,
  SING_PASS_CALLBACK,
  SING_PASS,
  NO_APPOINTMENT,
  STORY,
  XLANDING,
  XVERIFICATION,
  XAPPOINTMENT,
  XCONFIRMATION,
  XAPPOINTMENTDETAIL,
  XCANCELSUCCESS,
  XCHOOSEIDTYPE,
  O2FORM,
  O2IDENTITY,
  O2FORM_MID_SID,
  O2FORM_MID,
  O2APPOINTMENT_ENTRY,
  O2CONTACT_DETAIL,
  O2APPOINTMENT_REVIEW,
  O2APPOINTMENT_INFO,
  O2WELCOME_BACK,
  O2DELETED
} from "constants/route";
import ProtectedRoute2 from "./protectedRoute2";
import O2Form from "pages/o2Form";
import O2Identity from "pages/o2Identity";
import O2AppointmentEntry from "pages/o2AppoitnmentEntry";
import O2ContactDetail from "pages/o2ContactDetail";
import O2AppointmentReview from "pages/o2AppointmentReview";
import O2AppointmentInfo from "pages/o2AppointmentInfo";
import O2AppointmentWelcome from "pages/o2AppointmentWelcome";
import O2AppointmentDeleted from "pages/o2AppointmentDeleted";
import O2FormPage from "pages/o2Form";
import O2SingPassCallBack from "pages/o2SingPassCallback";

const RootNavigator = () => {
  useEffect(() => {
    console.log("root sideeffect");
  }, []);
  return (
    <Router basename={process.env.PUBLIC_URL}>
      <Routes>
        {/* 
        <Route path={DEFAULT_ROUTE} element={<Navigate replace to={MAIN} />} />
        <Route path={MAIN} element={<Service />} /> 
        */}
        <Route path={DEFAULT_ROUTE} element={<Navigate replace to={O2FORM} />} />
        <Route path={O2FORM} element={<O2Form />} />
        <Route path={SUB_SERVICE} element={<SubService />} />
        <Route path={SUB_SERVICE_DETAIL} element={<ServiceDetail />} />
        <Route path={CANCELLATION} element={<Cancellation />} />
        <Route path={BOOKED} element={<Booked />} />
        <Route
          path={APPOINTMENT_BOOKING}
          element={
            <ProtectedRoute>
              <AppointmentBooking />
            </ProtectedRoute>
          }
        />
        <Route path={APPOINTMENT} element={<Appointment />} />
        <Route path={SERVICE_CHANNEL} element={<ServiceChannel />} />
        <Route path={ACTION_CONFIRMATION} element={<ActionConfirmation />} />
        <Route path={OTP_FORM} element={<OtpForm />} />
        <Route
          path={APPOINTMENT_CONFIRMATION}
          element={
            <ProtectedRoute>
              <ApptBookingConfirmation />
            </ProtectedRoute>
          }
        />
        <Route
          path={APPOINTMENT_ACKNOWLEDGEMENT}
          element={
            <ProtectedRoute>
              <ApptBookingAcknowledgement />
            </ProtectedRoute>
          }
        />
        <Route
          path={CALL_APPOINTMENT_CONFIRMATION}
          element={
            <ProtectedRoute>
              <CallApptBookingConfirmation />
            </ProtectedRoute>
          }
        />
        <Route
          path={CALL_APPOINTMENT_ACKNOWLEDGEMENT}
          element={
            <ProtectedRoute>
              <CallApptBookingAcknowledgement />
            </ProtectedRoute>
          }
        />
        <Route
          path={APPOINTMENT_EXISTENCE}
          element={
            <ProtectedRoute>
              <AppointmentExistence />
            </ProtectedRoute>
          }
        />
        <Route path={SING_PASS} element={<SingPass />} />
        <Route path={SING_PASS_CALLBACK} element={<O2SingPassCallBack />} />
        <Route
          path={NO_APPOINTMENT}
          element={
            <ProtectedRoute>
              <NoAppointment />
            </ProtectedRoute>
          }
        />
        <Route path={STORY} element={<Story />} />

        {/*<Route path={XLANDING} element={<XLanding />} />
        <Route
          path={XCHOOSEIDTYPE}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) => xAppointment.ack !== null}
              ifFailGoTo={XLANDING}>
              <XChooseIdType />
            </ProtectedRoute2>
          }
        />
        <Route
          path={XVERIFICATION}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) =>
                xAppointment.ack !== null && xAppointment.haveCpfAccountNumber !== null
              }
              ifFailGoTo={XLANDING}>
              <XVerification />
            </ProtectedRoute2>
          }
        />
        <Route
          path={XAPPOINTMENT}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) => xAppointment.otpToken !== null}
              ifFailGoTo={XLANDING}>
              <XAppointment />
            </ProtectedRoute2>
          }
        />
        <Route
          path={XCONFIRMATION}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) =>
                xAppointment.otpToken !== null && xAppointment.timeslotId !== null
              }
              ifFailGoTo={XLANDING}>
              <XConfirmation />
            </ProtectedRoute2>
          }
        />

        <Route
          path={XAPPOINTMENTDETAIL}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) => xAppointment.otpToken !== null}
              ifFailGoTo={XLANDING}>
              <XAppointmentDetail />
            </ProtectedRoute2>
          }
        />

        <Route
          path={XCANCELSUCCESS}
          element={
            <ProtectedRoute2
              isAuthOk={({ xAppointment }) => xAppointment.otpToken !== null}
              ifFailGoTo={XLANDING}>
              <XCancelSuccess />
            </ProtectedRoute2>
          }
        />*/}

        <Route path={O2FORM} element={<O2Form />} />

        <Route path={O2FORM_MID} element={<O2Form />} />

        <Route path={O2FORM_MID_SID} element={<O2Form />} />

        <Route
          path={O2IDENTITY}
          element={
            <ProtectedRoute2
              isAuthOk={({ o2Appointment }) => o2Appointment.ack !== null}
              ifFailGoTo={O2FORM}>
              <O2Identity />
            </ProtectedRoute2>
          }
        />

        <Route
          path={O2APPOINTMENT_ENTRY}
          element={
            <ProtectedRoute2
              isAuthOk={({ o2Appointment }) => {
                return o2Appointment.ack !== null &&
                  (o2Appointment.nricFin !== null || o2Appointment.passport !== null)
                }
              }
              ifFailGoTo={O2FORM}>
              <O2AppointmentEntry />
            </ProtectedRoute2>
          }
        />

        <Route
          path={O2CONTACT_DETAIL}
          element={
            <ProtectedRoute2
              isAuthOk={({ o2Appointment }) => o2Appointment.apptTimeslotId !== null}
              ifFailGoTo={O2FORM}>
              <O2ContactDetail />
            </ProtectedRoute2>
          }
        />

        <Route
          path={O2APPOINTMENT_REVIEW}
          element={
            <ProtectedRoute2
              isAuthOk={({ o2Appointment }) =>
                o2Appointment.mobileNumber !== null ||
                o2Appointment.email !== null ||
                o2Appointment.mobileUseUCD ||
                o2Appointment.emailUseUCD
              }
              ifFailGoTo={O2FORM}>
              <O2AppointmentReview />
            </ProtectedRoute2>
          }
        />

        <Route
          path={O2APPOINTMENT_INFO}
          element={
            <ProtectedRoute2
              isAuthOk={({ o2Appointment, signPassIdentify }) => {
                // return o2Appointment.bookingTxnId !== null
                return (signPassIdentify.isLogin 
                    || (o2Appointment.nricFin !== null || o2Appointment.passport !== null) /* creating appt or welcome back */
                    // || (o2Appointment.hasApptNricFin !== null && o2Appointment.otpToken) /* come from identity page */
                    // || (o2Appointment.hasApptPassport !== null && o2Appointment.otpToken) /* come from identity page */
                ) 
              }}
              ifFailGoTo={O2FORM}>
              <O2AppointmentInfo />
            </ProtectedRoute2>
          }
        />

        <Route path={O2WELCOME_BACK} element={<O2AppointmentWelcome />} />
        <Route path={O2DELETED} element={<O2AppointmentDeleted />} />
      </Routes>
    </Router>
  );
};

export default RootNavigator;
